var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GFL-Marketing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFL---Fighters",
    transform: "translate(-1396, -2358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0, 2125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1397, 234)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    stroke: "#DEC371",
    strokeWidth: 2,
    fill: "#1A1A1A",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,37 L32.0769231,37 L32.0769231,28.340393 C32.0769231,25.9648472 31.0344615,24.639738 29.1649231,24.639738 C27.1304615,24.639738 25.9230769,26.020524 25.9230769,28.340393 L25.9230769,37 L21,37 L21,20.915575 L25.9230769,20.915575 L25.9230769,22.7244541 C25.9230769,22.7244541 27.4676923,20 30.9483077,20 C34.4301538,20 37,22.1355167 37,26.5550218 L37,37 L37,37 Z M16.000614,19 C14.3430266,19 13,17.6563707 13,15.9993904 C13,14.3436293 14.3430266,13 16.000614,13 C17.6569725,13 19,14.3436293 19,15.9993904 C19.0012279,17.6563707 17.6569725,19 16.000614,19 L16.000614,19 Z M13,37 L19,37 L19,21 L13,21 L13,37 Z",
    id: "linkedin-[#161]",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.e7d28e55a81067af51ea76aced0bd0fd.svg";
export { ForwardRef as ReactComponent };